import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import NTMButton from "components/Buttons/NTMButton";
import PageWithModal from "../../components/Page/PageWithModal";
import ProfileTable from "./ProfileTable";
import { Row } from "components/Layout";
import UserModal from "components/Modal/UserModal";

import { clearAction, updateMeAction } from '../../redux/users/userActions';
import { roles } from "../../constants";


export default function ProfileContainer() {
	const dispatch = useDispatch();

	const profile = useSelector(store => store.users.data)
	const loading = useSelector(store => store.users.loading)
	const success = useSelector(store => store.users.success)
	const error = useSelector(store => store.users.error)

	let [isModalOpen, setModalOpen] = useState(false)
	let [user, setUser] = useState(false)

	function clear() {
		dispatch(clearAction())
	}

	function updateUser(user) {
		dispatch(updateMeAction(user))
		setModalOpen(false)
		setUser(null)
	}

	let tables = [];
	let sections = [];

	sections.push({
		title: "Dati utente",
		data: [
			{
				name: 'name',
				label: "Nome",
				value: profile.firstName
			},
			{
				name: 'surname',
				label: "Cognome",
				value: profile.lastName
			},
			{
				name: 'email',
				label: "Email",
				value: profile.email
			},
			{
				name: 'phone',
				label: "Telefono",
				value: profile.phoneNumber
			},
		]
	});

	return (
		<PageWithModal
			loading={loading}
			error={error}
			success={success}
			clear={clear}
		>
			<ProfileTable
				title={profile.firstName + " " + profile.lastName}
				tables={tables}
				sections={sections}
			/>
			{roles.isAdmin(profile) && <Row style={{justifyContent: "center"}}>
				<NTMButton primary
					onClick={() => { setModalOpen(true); setUser(profile) }}
				>Modifica</NTMButton>
			</Row>}

			<UserModal
				loggedUser={profile}
				defaultValue={user}
				open={isModalOpen}
				onClose={() => { setModalOpen(false); setUser(null) }}
				onSubmit={updateUser}
			/>
		</PageWithModal>
	)
}
